import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configurations } from '../interfaces/configurations';
import { singleRequestPromiseFactory } from '@beecode/msh-node-util/lib/cache/single-request-promise';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsService {
  prefix = `${environment.serverUrl}/configurations`;
  // tslint:disable-next-line:variable-name
  protected _singleGetMyCompany = singleRequestPromiseFactory(async () =>
    this.http.get<Configurations>(`${this.prefix}/company`).toPromise(),
  );

  constructor(private http: HttpClient) {}

  async getMyCompany(): Promise<Configurations> {
    return this._singleGetMyCompany.promise();
  }

  async editMyCompany(companyInfo): Promise<Configurations> {
    return await this.http.put<Configurations>(`${this.prefix}/company`, companyInfo).toPromise();
  }
  async postPodEmail(email: string): Promise<string[]> {
    return this.http
      .post<string[]>(`${this.prefix}/company/pod-emails`, { email })
      .toPromise();
  }
}
